export const CLASS_NAMES = {
  wrapper: 'mb-4 text-14-22-em text-lavendar-200',
  item: 'text-14-22-em text-lavender-200',
  itemEmphasised: 'text-lavender-300',
};
